// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21dQM","badges":"styles_badges__2wV4l"};